<div class="flex flex-col w-full px-6 pb-6">
  <div
    class="flex w-full px-6 pb-2"
    [ngClass]="selectionList.orientation === 1 ? 'flex-col space-y-2' : 'flex-wrap gap-2'"
  >
    <div
      class="flex flex-row space-x-2 items-center"
      *ngFor="let option of selectionList.options"
    >
      <div class="w-4 h-4 bg-gray-200 rounded-full"></div>
      <span class="text-md">{{ option.text }}</span>
    </div>
  </div>
  <span class="mt-1 text-md text-hint">{{ field.description }}</span>
</div>
